import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../Contexts/AuthenticateProvider";
import { useSocketPresence } from "../Contexts/SocketPresenceProvider";
import Layout from "../Layout";
import FullPageLoader from "../Components/FullPageLoader";

function PrivateRoutes({ children }) {
    const { isAuthenticated, profileLoading } = useAuth();
    const location = useLocation();
    const { reportPageChange } = useSocketPresence() || {};
    useEffect(() => {
        if (isAuthenticated) reportPageChange?.(location.pathname);
    }, [isAuthenticated, location.pathname, reportPageChange]);

    if (!isAuthenticated) {
        return <Navigate to="/" replace state={{ from: location.pathname }} />;
    }
    
    if (profileLoading) {
        return <FullPageLoader />;
    }

    return (
        <Layout>
            {children}
            <Outlet />
        </Layout>
    );
}

export default PrivateRoutes;
